$(document).ready(function(){
var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 200);
}
ALAcheck();
function customALA() {
var selector = $('#address_zip');
  if(selector.length > 0) {
    clearInterval(isALARendered);        
    $("#zip-list").on("click",function(){
      $("#get-rates").trigger("click");
    });
  }  
  $(".shipping-bg-light-grey").attr("open", true);
}
});

document.addEventListener('DOMContentLoaded', function () {
  const zipInput = document.querySelector('#shipping-calculator #address_zip');
  if (zipInput) {
    zipInput.placeholder = 'Enter postcode';
  }
});